export const en = {
  // Navigation
  profile: "Profile",
  salaryBenefits: "Salary ",
  attendance: "Attendance",
  leaveManagement: "Leave Management",
  employeeSelfServices: " Self Services",
  calendar: "Calendar",
  settingsLocked: "Settings ",
  escalation: "Escalation",
  groups: "Groups",
  messages: "Messages",

  // Loading
  loadingPermissions: "Loading permissions...",

  // Tooltips
  darkModeTooltip: "Switch to Dark Mode",
  lightModeTooltip: "Switch to Light Mode",

  // Common
  loading: "Loading...",
};

export default en;
